import { GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';

const isMobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;

function isTouchDevice(): boolean {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  const mq = (query: string): boolean => window.matchMedia(query).matches;

  if (
    ('ontouchstart' in window)
    || ((window as any).DocumentTouch && document instanceof (window as any).DocumentTouch)
  ) {
    return true;
  }

  const query = [ '(', prefixes.join('touch-enabled),('), 'heartz', ')' ].join('');

  return mq(query);
}

interface NoticeState {
  isMobile: boolean,
  isTouchDevice: boolean
}

const namespaced: boolean = true;

const state: NoticeState = {
  isMobile: isMobileRegex.test(window.navigator.userAgent),
  isTouchDevice: isTouchDevice()
};

const getters: GetterTree<NoticeState, RootState> = {};

const actions = {};

const mutations: MutationTree<NoticeState> = {};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
